<template>
  <div class="left">
    <div class="trade">
      <router-link to="/normalRegister">
        <h3>普通版</h3>
        <p>一个订单只可支持一个收件人</p>
      </router-link>
    </div>
    <div class="merchant">
      <router-link to="/merchantInfo">
        <h3>商家版</h3>
        <p>特点:</p>
        <p>1、<span>一取多投</span>，一个订单最多可支持 <span>三个收件人</span></p>
        <p>2、<span>一键下单</span>，实现百度外卖、美团外卖、饿了么订单在一线快递中 <span>一键下单</span>
          ，方便快捷
        </p>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less" type="text/less">
  .left{
    margin-top:80px;
    margin-right: 120px;
    float: left;
    div{
      width: 600px;
      height: 280px;
      margin-bottom: 40px;
      border-radius:24px;
      &.trade{
        background: #F6F6F6;
        h3{
          font-size: 32px;
          color:#333;
          font-weight: 700;
          text-align: center;
          padding-top:98px;
          box-sizing: border-box;
        }
        p{
          margin-top:39px;
          font-weight: 500;
          color:#333;
          text-align: center;
        }
      }
      &.merchant{
        background: #F08200;
        h3{
          font-size: 32px;
          color:#fff;
          font-weight: 700;
          text-align: center;
          padding-top:49px;
          box-sizing: border-box;
          margin-bottom: 39px;
        }
        p{
          width: 301px;
          margin:auto;
          color:#fff;
          margin-bottom: 19px;
          line-height: 20px;
          span{
            color:#fff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/Left.vue